import api from '../../utils/api';

export const batchRemoveUnitModels = (propertyId: string, unitIds: Array<string>) => {
  return api.delete({
    url: `/property/${propertyId}/unit-model/batch`,
    variables: {
      unitIds,
    },
  });
};
